<script setup>
import { Head } from '@inertiajs/vue3';

// Components
import Footer from '@/Components/Footer/Footer.vue';
import Header from '@/Components/Header.vue';
import Notifications from '@/Components/Notifications.vue';

const props = defineProps({
    title: String,
    description: String,
});

</script>

<template>
    <Head>
        <title>{{ title }}</title>
        <meta
            head-key="description"
            name="description"
            :content="description"
        >
    </Head>
    <div class="relative flex min-h-screen flex-col">
        <!-- Page Header -->
        <Header />
        <!-- / Page Header -->

        <Notifications />

        <!-- Page Content -->
        <main>
            <slot />
        </main>
        <!-- / Page Content -->

        <Footer class="mt-auto" />
    </div>
</template>
